export { default } from './ActiveTagBar'
